// @ts-nocheck
// get rate lists
export const FETCH_RATE_LIST_REQUEST = "FETCH_RATE_LIST_REQUEST";
export const FETCH_RATE_LIST_SUCCESS = "FETCH_RATE_LIST_SUCCESS";
export const FETCH_RATE_LIST_FAILURE = "FETCH_RATE_LIST_FAILURE";

// add rate list
export const CREATE_RATE_LIST_REQUEST = "CREATE_RATE_LIST_REQUEST";
export const CREATE_RATE_LIST_SUCCESS = "CREATE_RATE_LIST_SUCCESS";
export const CREATE_RATE_LIST_FAILURE = "CREATE_RATE_LIST_FAILURE";

// edit rate list
export const EDIT_RATE_LIST_REQUEST = "EDIT_RATE_LIST_REQUEST";
export const EDIT_RATE_LIST_SUCCESS = "EDIT_RATE_LIST_SUCCESS";
export const EDIT_RATE_LIST_FAILURE = "EDIT_RATE_LIST_FAILURE";

export const EDIT_RATE_LIST_LOCALLY = "EDIT_RATE_LIST_LOCALLY";

// update rate on rate list
export const UPDATE_RATE_ON_RATE_LIST_REQUEST =
  "UPDATE_RATE_ON_RATE_LIST_REQUEST";
export const UPDATE_RATE_ON_RATE_LIST_SUCCESS =
  "UPDATE_RATE_ON_RATE_LIST_SUCCESS";
export const UPDATE_RATE_ON_RATE_LIST_FAILURE =
  "UPDATE_RATE_ON_RATE_LIST_FAILURE";

// delete rate list position
export const DELETE_RATE_LIST_POSITION_REQUEST =
  "DELETE_RATE_LIST_POSITION_REQUEST";
export const DELETE_RATE_LIST_POSITION_SUCCESS =
  "DELETE_RATE_LIST_POSITION_SUCCESS";
export const DELETE_RATE_LIST_POSITION_FAILURE =
  "DELETE_RATE_LIST_POSITION_FAILURE";

// fetch rate list on specific conditions like city/client or master

// update state of rate list
export const UPDATE_RATE_LIST_STATUS_REQUEST =
  "UPDATE_RATE_LIST_STATUS_REQUEST";
export const UPDATE_RATE_LIST_STATUS_SUCCESS =
  "UPDATE_RATE_LIST_STATUS_SUCCESS";
export const UPDATE_RATE_LIST_STATUS_FAILURE =
  "UPDATE_RATE_LIST_STATUS_FAILURE";

// fetch rate list for a particular client city etc
export const FETCH_SPECIFIC_RATE_LIST_REQUEST =
  "FETCH_SPECIFIC_RATE_LIST_REQUEST";
export const FETCH_SPECIFIC_RATE_LIST_SUCCESS =
  "FETCH_SPECIFIC_RATE_LIST_SUCCESS";
export const FETCH_SPECIFIC_RATE_LIST_FAILURE =
  "FETCH_SPECIFIC_RATE_LIST_FAILURE";

// toggle rate list enable disable
export const TOGGLE_RATE_LIST_REQUEST = "TOGGLE_RATE_LIST_REQUEST";
export const TOGGLE_RATE_LIST_SUCCESS = "TOGGLE_RATE_LIST_SUCCESS";
export const TOGGLE_RATE_LIST_FAILURE = "TOGGLE_RATE_LIST_FAILURE";

// toggle visibility rate list
export const TOGGLE_VISIBILITY_LIST_REQUEST = "TOGGLE_VISIBILITY_LIST_REQUEST";
export const TOGGLE_VISIBILITY_LIST_SUCCESS = "TOGGLE_VISIBILITY_LIST_SUCCESS";
export const TOGGLE_VISIBILITY_LIST_FAILURE = "TOGGLE_VISIBILITY_LIST_FAILURE";

// share rate list with client
export const SHARE_RATE_LIST_WITH_CLIENT_REQUEST =
  "SHARE_RATE_LIST_WITH_CLIENT_REQUEST";
export const SHARE_RATE_LIST_WITH_CLIENT_SUCCESS =
  "SHARE_RATE_LIST_WITH_CLIENT_SUCCESS";
export const SHARE_RATE_LIST_WITH_CLIENT_FAILURE =
  "SHARE_RATE_LIST_WITH_CLIENT_FAILURE";

// remove city from rate list
export const REMOVE_CITY_FROM_RATE_LIST_REQUEST =
  "REMOVE_CITY_FROM_RATE_LIST_REQUEST";
export const REMOVE_CITY_FROM_RATE_LIST_SUCCESS =
  "REMOVE_CITY_FROM_RATE_LIST_SUCCESS";
export const REMOVE_CITY_FROM_RATE_LIST_FAILURE =
  "REMOVE_CITY_FROM_RATE_LIST_FAILURE";

// remove city from rate list
export const ADD_NEW_CITY_TO_RATE_LIST_REQUEST =
  "ADD_NEW_CITY_TO_RATE_LIST_REQUEST";
export const ADD_NEW_CITY_TO_RATE_LIST_SUCCESS =
  "ADD_NEW_CITY_TO_RATE_LIST_SUCCESS";
export const ADD_NEW_CITY_TO_RATE_LIST_FAILURE =
  "ADD_NEW_CITY_TO_RATE_LIST_FAILURE";

// add city to rate list
export const ADD_CITY_TO_RATE_LIST_REQUEST = "ADD_CITY_TO_RATE_LIST_REQUEST";
export const ADD_CITY_TO_RATE_LIST_SUCCESS = "ADD_CITY_TO_RATE_LIST_SUCCESS";
export const ADD_CITY_TO_RATE_LIST_FAILURE = "ADD_CITY_TO_RATE_LIST_FAILURE";

// delelte rate list
export const DELETE_RATE_LIST_REQUEST = "DELETE_RATE_LIST_REQUEST";
export const DELETE_RATE_LIST_SUCCESS = "DELETE_RATE_LIST_SUCCESS";
export const DELETE_RATE_LIST_FAILURE = "DELETE_RATE_LIST_FAILURE";

// update rate list content
export const UPDATE_RATE_LIST_CONTENT_REQUEST =
  "UPDATE_RATE_LIST_CONTENT_REQUEST";
export const UPDATE_RATE_LIST_CONTENT_SUCCESS =
  "UPDATE_RATE_LIST_CONTENT_SUCCESS";
export const UPDATE_RATE_LIST_CONTENT_FAILURE =
  "UPDATE_RATE_LIST_CONTENT_FAILURE";

// fetch rate list for assign
export const FETCH_RATE_CLIENT_LIST_REQUEST = "FETCH_RATE_CLIENT_LIST_REQUEST";
export const FETCH_RATE_CLIENT_LIST_SUCCESS = "FETCH_RATE_CLIENT_LIST_SUCCESS";
export const FETCH_RATE_CLIENT_LIST_FAILURE = "FETCH_RATE_CLIENT_LIST_FAILURE";

// fetch city list
export const FETCH_CITY_LIST_FOR_CLIENT_REQUEST =
  "FETCH_CITY_LIST_FOR_CLIENT_REQUEST";
export const FETCH_CITY_LIST_FOR_CLIENT_SUCCESS =
  "FETCH_CITY_LIST_FOR_CLIENT_SUCCESS";
export const FETCH_CITY_LIST_FOR_CLIENT_FAILURE =
  "FETCH_CITY_LIST_FOR_CLIENT_FAILURE";

// save rate list
export const SAVE_RATE_LIST_FOR_EVENT_REQUEST =
  "SAVE_RATE_LIST_FOR_EVENT_REQUEST";
export const SAVE_RATE_LIST_FOR_EVENT_SUCCESS =
  "SAVE_RATE_LIST_FOR_EVENT_SUCCESS";
export const SAVE_RATE_LIST_FOR_EVENT_FAILURE =
  "SAVE_RATE_LIST_FOR_EVENT_FAILURE";

// update rate list position data
export const UPDATE_RATE_LIST_POSITION_DATA = "UPDATE_RATE_LIST_POSITION_DATA";

// manage master tier cities
export const MANAGE_MASTER_TIER_CITIES_REQUEST =
  "MANAGE_MASTER_TIER_CITIES_REQUEST";
export const MANAGE_MASTER_TIER_CITIES_SUCCESS =
  "MANAGE_MASTER_TIER_CITIES_SUCCESS";
export const MANAGE_MASTER_TIER_CITIES_FAILURE =
  "MANAGE_MASTER_TIER_CITIES_FAILURE";

// remove master tier cities
export const REMOVE_MASTER_TIER_CITIES_REQUEST =
  "REMOVE_MASTER_TIER_CITIES_REQUEST";
export const REMOVE_MASTER_TIER_CITIES_SUCCESS =
  "REMOVE_MASTER_TIER_CITIES_SUCCESS";
export const REMOVE_MASTER_TIER_CITIES_FAILURE =
  "REMOVE_MASTER_TIER_CITIES_FAILURE";

// fetch master tier cities
export const FETCH_MASTER_TIER_CITIES_REQUEST =
  "FETCH_MASTER_TIER_CITIES_REQUEST";
export const FETCH_MASTER_TIER_CITIES_SUCCESS =
  "FETCH_MASTER_TIER_CITIES_SUCCESS";
export const FETCH_MASTER_TIER_CITIES_FAILURE =
  "FETCH_MASTER_TIER_CITIES_FAILURE";

// update tier city request
export const UPDATE_TIER_CITY_REQUEST = "UPDATE_TIER_CITY_REQUEST";
export const UPDATE_TIER_CITY_SUCCESS = "UPDATE_TIER_CITY_SUCCESS";
export const UPDATE_TIER_CITY_FAILURE = "UPDATE_TIER_CITY_FAILURE";

// toggle client default rate for client
export const TOGGLE_DEFAULT_RATE_FOR_CLIENT_REQUEST =
  "TOGGLE_DEFAULT_RATE_FOR_CLIENT_REQUEST";
export const TOGGLE_DEFAULT_RATE_FOR_CLIENT_SUCCESS =
  "TOGGLE_DEFAULT_RATE_FOR_CLIENT_SUCCESS";
export const TOGGLE_DEFAULT_RATE_FOR_CLIENT_FAILURE =
  "TOGGLE_DEFAULT_RATE_FOR_CLIENT_FAILURE";

// toggle show integration rates
export const TOGGLE_INTEGRATION_RATES_FOR_CLIENT_REQUEST =
  "TOGGLE_INTEGRATION_RATES_FOR_CLIENT_REQUEST";
export const TOGGLE_INTEGRATION_RATES_FOR_CLIENT_SUCCESS =
  "TOGGLE_INTEGRATION_RATES_FOR_CLIENT_SUCCESS";
export const TOGGLE_INTEGRATION_RATES_FOR_CLIENT_FAILURE =
  "TOGGLE_INTEGRATION_RATES_FOR_CLIENT_FAILURE";

// show / hide integration section
export const TOGGLE_INTEGRATION_SECTION = "TOGGLE_INTEGRATION_SECTION";

// show tier options
export const SHOW_TIER_RATE_LIST_REQUEST = "SHOW_TIER_RATE_LIST_REQUEST";
export const SHOW_TIER_RATE_LIST_SUCCESS = "SHOW_TIER_RATE_LIST_SUCCESS";
export const SHOW_TIER_RATE_LIST_FAILURE = "SHOW_TIER_RATE_LIST_FAILURE";